// extracted by mini-css-extract-plugin
export default {"title":"IncomingEvents_title__tLrBH"};